import { render } from "./BaseUpdate.vue?vue&type=template&id=1bafa36a"
import script from "./BaseUpdate.vue?vue&type=script&lang=js"
export * from "./BaseUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__